import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-281b033a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "date-picker-input" }
const _hoisted_2 = {
  key: 0,
  class: "date-picker-input__help"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Calendar, {
      inputId: _ctx.fieldName,
      modelValue: _ctx.selectedDate,
      placeholder: _ctx.config.placeholder || 'DD-MM-YYYY',
      showButtonBar: true,
      showIcon: true,
      baseZIndex: 1100,
      appendTo: "body",
      dateFormat: "dd-mm-yy",
      "onUpdate:modelValue": _ctx.updateValue
    }, null, 8, ["inputId", "modelValue", "placeholder", "onUpdate:modelValue"]),
    (_ctx.config.helpText)
      ? (_openBlock(), _createElementBlock("small", _hoisted_2, _toDisplayString(_ctx.config.helpText), 1))
      : _createCommentVNode("", true)
  ]))
}